import React, {useState, useEffect} from "react";
import Dialog from '@material-ui/core/Dialog';
import t from '../../../helpers/t';
import {Biscuit} from "../../../../utils";
import {resourcesActions, useSelector} from 'inbooma-api';
import {rbac} from "../../resources/index";
import ImageViewer from "../../../components/imgView/ImageView";
import {Div2, Span} from "../../resources/styled_components/divs";
import { moment} from "../../../../../vendor";
const ResourcesDialog = (props) => {
    const { handleCloseDialog, resources, dispatch, showNotification, locationName } = props;
    const [resourcePending, setResourcePending] = useState(null);
    const _patchResource = useSelector(state => state["resources_data"].patchResource);
    const [currentImage, setCurrentImage] = useState("");

    function returnBlob (blob) {
        setCurrentImage(URL.createObjectURL(blob));
    }

    useEffect(() => {
        if (_patchResource.success === "" || !resourcePending) {
            return;
        }

        if (_patchResource.success === true) {
          //  let clone = {...localResource};
          //  clone.status = _patchResource.data.status;
           // setLocalResource(clone);
            showNotification("success",_patchResource.data.id);
        } else {
            showNotification("warning",null,(typeof _patchResource.data.message !== 'undefined'?_patchResource.data.message:t('could_not_be_saved_${a}',{a:t('resource')},'capital')+' #'));
            console.log("Failed patching reservation!");
        }
        setResourcePending(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[_patchResource]);

    let hasResourceNbr = false;
    if (resources.length > 0) {
        resources.map((resource) => {
            if (resource.resource_nbr !== null) {
                hasResourceNbr = true;
            }
        });
    }

    const onChangeStatus = (status,resource) =>  {
        dispatch(resourcesActions.patchResource({
            resource_id: resource.id,
            data: {
                status: status.target.value
            },
            token: Biscuit.get('token'),
            parameters: {
                headers: {
                    'Accept-Language': language,
                    'Content-Language': language
                }
            }
        }));
        setResourcePending(resource.id);
    };

    const showContingentLocationName = false;
    return (
        <>
            <Dialog
                    onClose={handleCloseDialog}
                    aria-labelledby="sdf-dialog-title"
                    open={true}
                    name="resourceDialog"
                    id="resourceDialog"
                    maxWidth={"ld"}
                    style={{maxHeight:"600px", minWidth: "75%"}}
                >
                    <header className="inb-resources-header">

                        <button
                            onClick={handleCloseDialog}
                            type="button"
                            id="inb-resources-close-button"
                            className="button hollow secondary right button-close-resources-dialog round"
                            title={t("close show status")}
                        >
                            <i className="fi fi-x"></i>
                        </button>
                        <h4>{t('found resources', null, 'capital')} {locationName}</h4>
                        <div id="inb-c-main-header" >
                            <ul className="inb-tabs row" style={{maxWidth: "100%"}}>
                                <li className="tabs-title column large-1 medium-1 small-2">{t('id')}</li>
                                <li className="tabs-title column large-1 medium-1 small-6">{t('name',null,'capital')}</li>
                                <li className="tabs-title column large-2 medium-2 small-6">{t('contingent',null,'capital')}</li>
                                <li className="tabs-title column large-2 medium-2 small-6">{t('location',null,'capital')}</li>
                                <li className="tabs-title column large-1 medium-1 small-6">{t('status',null,'capital')}</li>
                                <li className="tabs-title column large-2 medium-2 small-6">{t('updated',null,'capital')}</li>
                                <li className="tabs-title column large-2 medium-2 small-6">{t('scantime',null,'capital')}</li>
                            </ul>
                        </div>
                    </header>

                <div id="inb-c-main-resources" className="inb-c-listing off-canvas-content" data-off-canvas-content="">
                    {resources.map((localResource, index) => {
                        let facilityType = typeof localResource.facility_slots[0]?.facility?.facility_type === 'undefined'?null: localResource.facility_slots[0]?.facility?.facility_type;
                        let facilityName = (facilityType === 'cyclepoint'?localResource.facility_slots[0]?.facility?.name:null);
                        let facilitySlotNbr = (facilityType === 'cyclepoint'?localResource.facility_slots[0]?.facility_slot_nbr:null);
                        if(facilityName !== null){
                            facilityName = <span>{facilityName + " Stellplatz " + facilitySlotNbr}</span>;
                        }
                        let act2 = localResource.id;
                        if(hasResourceNbr){
                            // act = "";
                            act2 = "";
                        }
                        let note = "";
                        if(localResource.note !== null){
                            note = localResource.note.substring(0,100);
                        }
                        let in_progress = false, no_station = false;
                        if(localResource.checkedInStatus === "inprogress" && localResource.status === 'active'){
                            in_progress = true;
                        }
                        if(typeof localResource.location_id_name === "undefined" && localResource.status === 'active'){
                            no_station = true;
                        }
                        const location_id_name = (in_progress)?t('inprogress'):((no_station)?t('no station'):localResource.location_id_name);
                        return(<>
                        <div className={"inb-c-item inb-c-item--resource row" + (localResource.status === 'active' ? ' not-marked' : (localResource.status === 'inactive' ? ' gray-marked' : ' red-marked'))}  key={"web_div_row_"+localResource.id+"_standard"}>
                            <div className="large-1 medium-1 small-2 column inb-order-big padding-1" id="order-id" key={"web_div_resource_id_"+localResource.id}>
                                <Span title={hasResourceNbr?t("external_resource_id_short"):"ID"} >
                                    {hasResourceNbr?localResource.resource_nbr:localResource.id}
                                </Span><br/>
                                <div title={"ID"} style={{textAlign:'left',paddingTop:"5px"}}>{act2}</div>
                            </div>
                            <div className="large-1 medium-1 small-6 column inb-order-big" id="name-bike" key={"div_resource_name_"+localResource.id}>
                                <span title={localResource.name} className="text-nowrap">{localResource.name}</span><br/>
                                <div title={note} style={{textAlign:'left',fontSize: ".8125rem", fontWeight: "normal"}}>{note}</div>
                            </div>
                            <div className="large-2 medium-2 small-6 column" id="inb-contingent" title={localResource.contingent.name}>{localResource.contingent.name}</div>
                            <div className="large-2 medium-2 small-6 column" title={localResource.location.name} style={{minHeight: "40px"}} key={"div_resource_location_"+localResource.id}>
                                <span className="text-nowrap">{localResource.location.name}</span><br/>
                                <span className="text-nowrap">{facilityName}</span>

                            </div>

                            <div className="large-1 medium-3 small-4 medium-offset-0 column padding-05" title="Status" key={"web_div_resource_status_"+localResource.id}>
                                {rbac.hasPermission('editStatus') &&
                                    <>{resourcePending === null ? <select
                                        className={index % 2 === 1 ? 'inbooma-select-box__input second-select' : 'inbooma-select-box__input'}
                                        name="status"
                                        onChange={e => onChangeStatus(e, localResource)}
                                        key={"web_select_resource_status_"+localResource.id}
                                        value={localResource.status === null ? '' : localResource.status}
                                        placeholder={t('select_${a}', {a: t('status')})}>
                                        {['active', 'inactive', 'defect'].map(status => {
                                            return (
                                                <>
                                                    <option key={'web_'+status+localResource.id} value={status}>{t(status)}</option>
                                                </>
                                            )
                                        })}
                                    </select>:<> <span><img alt="RollingLoader" className="rollingLoader colorize-black" src={"dist/img/rolling_loader.svg"} /> </span></>}</>
                                }
                                {!rbac.hasPermission('editStatus') &&
                                    <span>{t(localResource.status)}</span>
                                }
                            </div>
                            <div className="large-2 medium-2 small-1 medium-offset-0 column datetime-booking text-nowrap" title="Modifiziert am" key={"web_div_resource_modified_"+localResource.id}>{ moment(localResource.modified).format('DD.MM.YY HH:mm')}</div>
                            <div className="large-2 medium-2 small-1 medium-offset-0 column datetime-booking text-nowrap" title="Gescannt am" key={"web_div_resource_modified_"+localResource.id}>{ moment(localResource.scantime).format('DD.MM.YY HH:mm')}</div>
                            <div className="large-1 medium-2 small-6 medium-offset-0 column item-button-group" key={"div_resource_edit_"+localResource.id}>
                                {rbac.hasPermission('editResource') &&
                                    <div className="button-container-resources" key={"div_resource_button_container_edit_"+localResource.id}>
                                        <a
                                            href={"/resources/"+localResource.id}
                                            title={t('edit')}
                                            key={"web_a_resource_edit_"+localResource.id}
                                            data-inb-action-link="edit">
                                            <button type="button" className="inb-round-btn hollow round float-left" key={"web_a_button_resource_edit_"+localResource.id} style={{width:"34px",height:"34px"}}

                                            >
                                                <div className="inb-fi-edit" style={{marginLeft:"-3px"}}> </div>
                                            </button>
                                        </a>
                                    </div>
                                }
                                {rbac.hasPermission('write') &&
                                    <div className="button-container-resources"  key={"div_resource_button_container_delete_"+localResource.id}>
                                        <a
                                            href="#"
                                            className="inb-reservation__pdf2"
                                            title={t('delete')}
                                            key={"a_resource_delete_"+localResource.id}
                                            data-inb-action-link="delete">
                                            <button type="button" className="inb-round-btn hollow round float-left"
                                                    key={"web_a_button_resource_delete_"+localResource.id}
                                                    onClick={() => onRemoveResource(localResource)} style={{width:"34px",height:"34px"}}>
                                                <div className="inb-fi-remove" style={{marginLeft:"-3px"}}> </div>
                                            </button>
                                        </a>
                                    </div>
                                }
                                <div className="button-container-resources"  key={"div_resource_button_container_qr_"+localResource.id}>
                                    <a
                                        href="#"
                                        title={t('getQRCode')}
                                        key={"a_resource_qr_"+localResource.id}
                                        data-inb-action-link="delete">
                                        <button type="button" className="inb-round-btn hollow round float-left"
                                                key={"web_a_button_resource_qr_"+localResource.id}
                                                onClick={() => setCurrentImage(onGetQRCodeHandler(localResource, returnBlob))} style={{width:"34px",height:"34px"}}>
                                            <div className="inb-fi-qrcode" style={{marginLeft:"-3px"}}> </div>
                                        </button>
                                    </a>
                                </div>
                            </div>

                        </div>
                        </>);

                    })}


                </div>
            </Dialog>
        </>
    );
}

export default ResourcesDialog;